import { EVENT_TYPE } from '@hedepy/common/enums/EVENT_TYPE'
import z from 'zod'

import type { CartParamSlot } from '@/src/domains/cart/types'

const CartSlotsSchema = z
  .string()
  .or(
    z.array(
      z.string().or(
        z.object({
          startDate: z.string(),
          type: z.union([z.literal(EVENT_TYPE.ONLINE), z.literal(EVENT_TYPE.OFFLINE)]),
        }),
      ),
    ),
  )
  .optional()
  .default([])
  .catch([] as CartParamSlot[])
  .transform((val): CartParamSlot[] => {
    return (typeof val === 'string' ? [val] : val).map((item) => {
      if (typeof item === 'string') {
        return {
          startDate: item,
          type: EVENT_TYPE.ONLINE,
        } as CartParamSlot
      }
      return item as CartParamSlot
    })
  })

const PrebookingIdsSchema = z.array(z.coerce.number()).optional().default([]).catch([])

const CartOwnerIdSchema = z.number().optional().catch(undefined)

export const CartParamsSchema = z.object({
  therapistId: CartOwnerIdSchema,
  serviceId: CartOwnerIdSchema,
  selected: CartSlotsSchema,
  prebookingIds: PrebookingIdsSchema,
  voucher: z.string().optional(),
})
